<template>
  <div
    class="gmf-item-details-container"
    ref="container"
    :style="{ opacity: ! lootCratePos ? 1 : 0 }"
    @click="handleClick"
    @touchmove="handleTouchmove"
  >
    <button v-if="showCloseButton" class="gmf-modal-close-btn" @click="$emit('close')" aria-label="Close">
      <Icon icon="modal-close" />
    </button>
    <div class="gmf-p-4">
      <div class="gmf-item-details">
        <div v-if="item.itemBrand" class="gmf-item-brand gmf-item-brand-top-left">
          <img :src="item.itemBrand.iconUrl" loading="lazy" draggable="false" />
        </div>
        <div class="gmf-item-details-preview-container" :style="imageStyle">
          <div v-if="item.type === 'loot-crate' && item.quantity > 1" class="gmf-item-detail-quantity">
            {{ item.quantity }}
          </div>
          <img
            :src="avatarUrl"
            class="gmf-item-details-preview"
            @load="isImageLoaded = true"
            :style="{ opacity: isImageLoaded ? 1 : 0  }"
          />
          <LoadingSpinner v-if="! isImageLoaded" class="gmf-item-details-preview-loading" />
        </div>
        <div class="gmf-item-details-content">
          <div class="gmf-item-details-name">
            <span v-text="item.name"></span>
            <!-- <div class="gmf-item-rarity-label gmf-ml-2 gmf-text-small" :style="rarityLabelStyle" style="display: inline">{{ item.rarity }}</div> -->
          </div>
          <div class="gmf-item-details-info">
            <template v-if="item.type === 'item-bundle' || item.type === 'loot-crate'">
              <div class="gmf-text-small gmf-item-details-subtitle">
                {{ item.subtitle }}
              </div>
              <div class="gmf-item-details-description gmf-mt-3" v-max-lines:ellipsis="3">
                {{ item.description }}
              </div>
            </template>
            <template v-else>
              <div class="gmf-item-info-category gmf-item-details-subtitle gmf-text-small">{{ categoryTranslation }}</div>
            </template>
          </div> 
          <div class="gmf-item-details-color">
            <ColorPill v-if="selectedColor" :colors="selectedColor" class="gmf-mt-3" />
          </div>
        </div>
      </div>
      <ColorSelector
        v-if="colors.length > 0"
        :modelValue="selectedColor"
        @update:modelValue="selectColor"
        class="gmf-mt-4"
        :colors="colors"
        :unlockedColors="customerOwnedColors"
        />
    </div>

    <!-- Actions div -->
    <div class="gmf-item-details-footer">
      <div class="gmf-item-details-actions" :style="actionsStyle">
        <button v-if="item.type === 'loot-crate' && (! done && nextOpenTime > new Date().getTime().toString().slice(0, -3))" class="gmf-btn gmf-btn-primary gmf-disabled gmf-mb-0">
          <Countdown :prefixString="t('available_in')" :unixTimestamp="nextOpenTime" @done="done = true" />
        </button>
        <button v-else-if="!done && priceCountdown" class="gmf-btn gmf-btn-primary gmf-disabled gmf-mb-0">
          <Countdown :prefixString="t('available_in')" :unixTimestamp="priceCountdown" @done="done = true" />
        </button>
        <button v-else-if="item.type === 'loot-crate' && item.quantity >= 0" class="gmf-btn gmf-btn-primary gmf-mb-0" @click="openLootCrate">
          {{ lootCrateBtnPhrase }}
        </button>
        <button v-else-if="itemIsOwned" class="gmf-btn gmf-btn-primary gmf-mb-0 gmf-disabled" @click="showOwnedTooltip">
          {{ t('checkout.already_unlocked') }}
        </button>
        <button v-else-if="! selectedColor && colors.length > 0" class="gmf-btn gmf-btn-primary gmf-disabled gmf-mb-0" @click="showPickColorTooltip">
          {{ t('checkout.pick_color') }}
        </button>
        <button v-else class="gmf-btn gmf-btn-primary gmf-mb-0" @click="buy" v-html="unlockForHTML" :disabled="hasInsufficientFunds || isBuying" :aria-label="unlockForPhrase" />
        <div class="gmf-item-details-balance" v-if="! hideBalance" v-html="youHavePhrase" />
      </div>
      <div class="gmf-item-details-status">
        <template v-if="showErrors">
          <div class="gmf-subheader">
            Error
          </div>
          <div>
            {{ t('checkout.error') }}
          </div>
        </template>
        <template v-else-if="isBuying">
          <div class="gmf-subheader">
            {{ t('checkout.buying') }}
          </div>
          <LoadingSpinner class="gmf-mt-4" />
        </template>
      </div>
    </div>
  </div>
</template>
<style>
.gmf-item-details-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  border-top-left-radius: var(--gmf-modal-rounding);
  border-top-right-radius: var(--gmf-modal-rounding);
  background-color: var(--gmf-col-lightgray);
  user-select: none;
  opacity: 1;
  transition: opacity 0.3s ease-out;
}

.gmf-item-details-loot-crate-open {
  width: 448px;
  height: 448px;
  max-width: 448px;
  max-height: 448px;
  aspect-ratio: 1;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 60%);
  bottom: 50%;
  z-index: -1;
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  opacity: 0 !important;
  pointer-events: none;
  z-index: 1;
}

.gmf-item-detail-quantity {
  position: absolute;
  top: var(--gmf-p-5);
  right: var(--gmf-p-5);
  color: var(--gmf-col-white);
  background-color: var(--gmf-col-black);
  border-radius: 100%;
  padding: var(--gmf-p-3);
  align-items: center;
  overflow: visible;
  aspect-ratio: 1;
  display: flex;
}

.gmf-item-details-loot-crate-open.gmf-open {
  opacity: 1 !important;
  transform: translate(-50%, 50%);
}

.gmf-item-details-container .gmf-horizontal-pills-menu {
  flex-wrap: wrap;
  justify-content: center;
}

.gmf-item-details {
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  gap: var(--gmf-p-3);
  background-color: var(--gmf-card-col-ongray);
  border-radius: var(--gmf-modal-rounding);
  position: relative;
}

.gmf-item-details-container .gmf-token-shop-color-selector {
  flex-direction: column;
  display: flex;
  align-items: center;
}

.gmf-item-details-preview-container {
  border-top-left-radius: var(--gmf-modal-rounding);
  border-bottom-left-radius: var(--gmf-modal-rounding);
  overflow: hidden;
  flex-shrink: 0;
  line-height: 0;
  position: relative;
}

.gmf-item-details-preview {
  width: 120px;
  height: 100%;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  gap: var(--gmf-p-3);
  flex-wrap: wrap;
  object-fit: cover;
}

.gmf-item-details-preview-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

.gmf-item-details-name {
  font-weight: bold;
  color: var(--gmf-col-black);
}

.gmf-item-rarity-label {
  border-radius: var(--gmf-p-3);
  padding: var(--gmf-p-1) var(--gmf-p-2);
  color: var(--gmf-col-black) !important;
}

.gmf-item-details-color .gmf-item-color-pill {
  padding-left: 0;
}

.gmf-item-details-container .gmf-item-color-pill {
  width: 48px !important;
  height: 48px !important;
}

.gmf-item-details .gmf-color-pill-radius {
  width: 15px;
  height: 15px;
}

.gmf-item-details-status {
  position: absolute;
  display: flex;
  left: 0;
  right: 0;
  top: 0;
  flex-direction: column;
  align-items: center;
}

.gmf-item-details-footer {
  position: relative;
}

.gmf-item-details-actions {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--gmf-p-3);
  padding: var(--gmf-p-4);
  padding-top: 0;
}

.gmf-item-details-actions button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--gmf-p-2);
}

.gmf-item-details-actions .gmf-btn {
  width: fit-content;
  z-index: calc(var(--gmf-modal-z-index) + 2);
  height: 50px;
}

.gmf-item-details-content {
  display: flex;
  flex-direction: column;
  padding: var(--gmf-p-3) var(--gmf-p-4);
  min-height: 120px;
  flex-grow: 1;
}

.gmf-item-details-price {
  background-color: var(--gmf-col-white);
  padding-left: var(--gmf-p-2);
  padding-right: var(--gmf-p-3);
  padding-block: var(--gmf-p-2);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--gmf-p-3);
}

.gmf-item-details-balance {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--gmf-p-2);
}

.gmf-item-details .gmf-modal-close {
  position: relative;
}

.gmf-context .gmf-item-details-subtitle {
  color: var(--gmf-brand-color);
}
</style>
<script>
import state from '@/state';
import { v4 } from 'uuid';
import bus from '@/utils/eventbus';
import tooltip from '@/utils/tooltip';
import { isItemOwned, getBestPrice } from './utils';
const t = state.t.prefix('token_shop');
const tl = state.t.prefix('loot_crates');
import callApi from '@/utils/callApi';
import Icon from '@/components/Icon.vue';
import modalStack from '@/utils/modalStack';
import ColorSelector from './ColorSelector.vue';
import maxLines from '@/utils/directives/maxLines';
import advancedString from '@/utils/advancedString';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { getMyTokenBalance } from '@/utils/getMyTokenBalance';
import formatVirtualCurrency from '@/utils/formatVirtualCurrency';
import ColorPill from '@/components/AvatarConfigurator/colors/ColorPill.vue';
import openAvatarConfigurator from '@/components/AvatarConfigurator/openAvatarConfigurator';
import Countdown from '@/widgets/LootCrate/Countdown.vue';
import openLootCrate from '@/widgets/LootCrate/openLootCrate';

import { lootCrateStatus } from '../TokenShop/data.js';

export default {
  emits: ['success', 'selectColor', 'close', 'click', 'touchmove', 'error'],
  components: { ColorPill, LoadingSpinner, ColorSelector, Icon, Countdown },
  directives: {
    'max-lines': maxLines,
  },
  props: {
    item : {
      Type: Object,
      default: () => null,
    },
    showPrice: {
      Type: Boolean,
      default: false,
    },
    showCloseButton: {
      Type: Boolean,
      default: false,
    },
    hideBalance: {
      Type: Boolean,
      default: false,
    }
  },
  inject: {
    inventory: {
      default: () => null,
    },
  },
  data () {
    return {
      showSuccessPage: false,
      showErrors: false,
      isBuying: false,
      selectedColor: null,
      selectedRewardIndex: 0,
      isImageLoaded: false,
      done: false,
      openAnim: false,
      lootCratePos: false,
      modalState: {
        isTopModal: true,
      },
    };
  },
  created () {
    if (! state.tokenBalances) {
      getMyTokenBalance().then(tokenBalances => {
        state.tokenBalances = tokenBalances;
      });
    }

    if (this.colors.length === 1) {
      this.selectedColor = this.colors[0];
    }
  },
  mounted () {
    modalStack.push(this);
  },
  beforeUnmount () {
    modalStack.remove(this);
  },
  computed: {
    colors () {
      return this.item?.colors || [];
    },
    itemIsOwned () {
      if (! this.inventory) {
        return false;
      }

      return isItemOwned(this.inventory, this.item, this.selectedColor?.uuid);
    },
    customerOwnedColors () {
      if (! this.inventory) {
        return [];
      }

      const ownedColors = [];

      for (const item of this.inventory) {
        if (item.uuid === this.item.uuid && item.variation?.color) {
          ownedColors.push(item.variation.color);
        }
      }

      return ownedColors;
    },
    lootCrateBtnPhrase () {
      return this.item.quantity <= 1 ? tl('open_btn') : advancedString(tl('open_quantity'), { quantity: this.item.quantity });
    },
    unlockForHTML () {
      if (this.bestPrice.amount === 0) {
        return t('unlock_for_free');
      }

      return advancedString(t('unlock_for'), {
        amount: `<img src="${ this.bestPrice.token.icon }" class="gmf-token gmf-token-lg" /> <b>${ formatVirtualCurrency(this.bestPrice.amount) }</b>`,
        tokenName: this.bestPrice.token.shortName,
      });
    },
    unlockForPhrase () {
      if (this.bestPrice.amount === 0) {
        return t('unlock_for_free');
      }

      return advancedString(t('unlock_for'), {
        amount: formatVirtualCurrency(this.bestPrice.amount),
        tokenName: this.bestPrice.token.shortName,
      });
    },
    insufficientFundsPhrase () {
      return advancedString(t('checkout.insufficient_funds'), {
        tokenName: this.bestPrice.token.shortName,
      });
    },
    displayTokenIcon () {
      return this.bestPrice?.token?.icon;
    },
    displayTokenName () {
      return this.bestPrice?.token?.name;
    },
    youHavePhrase () {
      if (! this.bestPrice) {
        return state.t('token_shop.you_have_no_tokens');
      }

      let currentBalance = formatVirtualCurrency(this.currentUserBalance?.amount || 0);
      const tokenName = this.displayTokenName;

      return advancedString(state.t('token_shop.you_have'), {
        amount: `<img src="${ this.displayTokenIcon }" class="gmf-token" /> <b>${ currentBalance }</b>`,
        tokenName,
      });
    },
    avatarUrl() {
      if (this.item.type == 'profile-skin') {
        return this.item.url;
      }
      if (this.item?.type === 'avatar-3d-part' || this.item?.type === 'avatar-3d-color') {
        if (this.selectedColor) {
          return state.cdnBase + this.item.url + '/' + this.selectedColor.uuid;
        }
        return state.cdnBase + this.item.url;
      }
      if (this.item.type == 'loot-crate') {
        return this.item.imageUrl || this.item.beforeOpenImageUrl;
      }
      return this.item.url;
    },
    openLootCrateUrl() {
      if (this.item.type == 'loot-crate') {
        if (this.openAnim && this.item.openImageUrl) {
          return this.item.openImageUrl;
        }

        return this.item.beforeOpenImageUrl || this.item.imageUrl;
      }
      return this.item.url;
    },
    rarity () {
      return this.item.rarity;
    },
    imageStyle () {
      const style = {};

      style.background = `linear-gradient(25deg, var(--gmf-rarity-col-gradient-${ this.rarity }-1) 0%, var(--gmf-rarity-col-gradient-${ this.rarity }-2) 80%, var(--gmf-rarity-col-gradient-${ this.rarity }-3) 100%)`;

      return style;
    },
    priceStyle () {
      const style = {
        borderColor: 'var(--gmf-rarity-col-gradient-' + this.rarity + '-1)',
      };

      if (this.rarity === 'basic' || this.rarity === 'common') {
        style.backgroundColor = 'var(--gmf-col-gray)';
      } else {
        style.backgroundColor = 'var(--gmf-col-white)';
      }

      return style;
    },
    rarityLabelStyle () {
      return {
        backgroundColor: 'var(--gmf-rarity-col-' + this.rarity + ')',
      }
    },
    actionsStyle () {
      const style = {};

      if (this.isBuying || this.showErrors) {
        style.opacity = 0;
      }
      return style;
    },
    categoryTranslation () {
      if (this.item.type === 'avatar-3d-part') {
        return 'Avatardel - ' + state.t.prefix('avatar.slots')(this.item.category.id);
      } else if (this.item.type === 'avatar-3d-color') {
        return state.t.prefix('avatar.colors')(this.item.category.id);
      }
      return '';
    },
    bestPrice () {
      this.done; // Make sure the price gets recomputed when the countdown has finished.
      return getBestPrice(this.item);
    },
    currentUserBalance () {
      if (! this.bestPrice) {
        return null;
      }

      const balance = state.tokenBalances?.find(b => b.token.uuid === this.bestPrice.token.uuid);
      return balance;
    },
    priceCountdown () {
      if (this.bestPrice || ! this.item.prices) {
        // If there is an active price or no prices, no need to show a countdown.
        return false;
      }
      for (const price of this.item.prices) {
        if (price.startsAt && new Date() < new Date(price.startsAt)) {
          return (new Date(price.startsAt).getTime() / 1000) + "";
        }
      }

      return false;
    },  
    hasInsufficientFunds () {
      if (this.bestPrice.amount === 0) {
        return false;
      }

      if (! this.currentUserBalance) {
        return true;
      }

      return this.currentUserBalance.amount < this.bestPrice.amount;
    },
    nextOpenTime () {
      if (this.item.type !== 'loot-crate') {
        return 0;
      }

      if (lootCrateStatus[this.item.typeName]) {
        return lootCrateStatus[this.item.typeName].nextOpenTime;
      }
      return 0;
    },
  },
  methods: {
    t,
    showPickColorTooltip (ev) {
      tooltip.create({x: ev.pageX, y: ev.pageY}, t('checkout.pick_color'));
    },
    showOwnedTooltip (ev) {
      tooltip.create({x: ev.pageX, y: ev.pageY}, t('checkout.already_unlocked'));
    },
    async buy (ev) {
      if (this.hasInsufficientFunds) {
        tooltip.create({x: ev.pageX, y: ev.pageY}, this.insufficientFundsPhrase);
        return;
      }

      this.isBuying = true;

      const idempotencyKey = v4();

      const data = {
        priceId: this.bestPrice.uuid,
        colorId: this.selectedColor?.uuid,
      };


      try {
        const res = await callApi('POST', '/v1/client/token-shop/buy', data, {
          'X-GMF-Idempotency-Key': idempotencyKey,
        });
        const json = await res.json();

        if (json.error) {
          this.showErrors = true;
          this.isBuying = false;
          this.$emit('error');
          return;
        }

        if (json.balances) {
          state.tokenBalances = json.balances;
        } else {
          // Balances not returned, so we need to update it until the next refresh.
          this.changeTokenAmount(this.bestPrice.token.uuid, -this.bestPrice.amount);
        }

        if (this.item.type === 'loot-crate') {
          this.isBuying = true;

          try {
            const res = await openLootCrate(lootCrateStatus[this.item.typeName]);

            if (res.error) {
              this.error = res.error;
              tooltip.create({ x: ev.pageX, y: ev.pageY }, this.error);
              this.isBuying = false;
              return;
            }

            getMyTokenBalance().then(tokenBalances => {
              state.tokenBalances = tokenBalances;
            });
            this.$emit('success', { type: 'loot-crate', itemUuid: this.item.uuid });
          } catch (e) {
            this.isBuying = false;
            console.error(e);
          }
          return;
        }

        this.showSuccessPage = true;
        const rewardItems = json.rewardsGiven;

        this.isBuying = false;
        this.$emit('success', rewardItems);
      } catch (e) {
        // Purchase error.
        this.showErrors = true;
        this.isBuying = false;
        console.error(e);
        this.$emit('error');
      }
    },
    changeTokenAmount (tokenUuid, amount) {
      const balance = state.tokenBalances?.find(b => b.token.uuid === tokenUuid);
      if (balance) {
        balance.amount += amount;
      }
    },
    selectColor (color) {
      if (this.isBuying) {
        // Don't allow changing color while buying.
        return;
      }

      if (color === this.selectedColor) {
        // Don't allow selecting the same color.
        return;
      }

      this.isImageLoaded = false;
      this.selectedColor = color;
      this.$emit('selectColor', color);
    },
    close () {
      this.$emit('close');
    },
    openAvatarConfigurator () {
      bus.emit('modal.close');
      openAvatarConfigurator();
    },
    handleClick (ev) {
      this.$emit('click', ev);
    },
    handleTouchmove (ev) {
      this.$emit('touchmove', ev);
    },
  },
  watch: {
    selectedColor () {
      // Reset the success/error page.
      this.showSuccessPage = false;
      this.showErrors = false;
    },
  },
};
</script>
